import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'

export interface SystemConfigReq {
  /** 参数键 */
  config_key: string
}

export interface SystemConfigRes {
  /** 配置名称 */
  config_name?: string
  /** 参数建 */
  config_key?: string
  /** 参数值 */
  config_value?: string
  /** 备注 */
  remark?: string
}

export interface EditSystemConfigReq {
  /** 配置名称 */
  config_name?: string
  /** 参数key: AuthenticSoftwareNotice(正版软件超限通知设置Key),.... */
  config_key?: string
  /** 参数值 */
  config_value?: string
  /** 备注 */
  remark?: string
}

@Injectable()
export class SystemConfigService {
  constructor (private http: Http) {
  }

  getSystemConfig (data: SystemConfigReq) {
    return this.http.post<SystemConfigRes>('/teamconfig/get', data)
  }

  editSystemConfig (data: EditSystemConfigReq) {
    return this.http.post<void>('/teamconfig/add', data)
  }
}
